import {
	Card,
	CardHeader,
	CardContent,
	Divider,
	Table,
	TableBody,
	TableRow,
	TableCell,
} from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { useAuthorize } from '~features/authentication';

import { useStyles } from './style';

interface GeneralInfoProps {
	className?: string;
	userGroup: object;
}

const GeneralInfo = (props: GeneralInfoProps) => {
	const { userGroup, className } = props;
	const { t } = useTranslation();
	const { isSuperAdmin } = useAuthorize();

	const classes = useStyles();

	const tableRows = [
		{ label: t('ui.label.name'), content: userGroup.name },
		...(userGroup.description ?
			[{ label: t('ui.label.description'), content: userGroup.description }]
		:	[]),
		...(isSuperAdmin() ?
			[{ label: t('ui.label.organisation'), content: userGroup.organisationReference.name }]
		:	[]),
		{ label: t('ui.category.users'), content: userGroup.totalUsers },
		{
			label: t('views.userManagement.userGroup.details.label.itemGroup'),
			content: userGroup.totalItems,
		},
		{
			label: t('views.userManagement.userGroup.details.label.item'),
			content: userGroup.totalItemInstances,
		},
	];

	return (
		<Card className={clsx(classes.root, className)}>
			<CardHeader title={t('views.policyDetail.summary.cardHeaders.general')} />
			<Divider />
			<CardContent className={classes.content}>
				<Table>
					<TableBody>
						{tableRows.map((tableRow, index) => (
							<TableRow className={classes.tableRow} key={`table-row-${index}`}>
								<TableCell>{tableRow.label}</TableCell>
								<TableCell>{tableRow.content}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</CardContent>
		</Card>
	);
};

export default GeneralInfo;
